import React from 'react';

const TrashCanIcon = props => (
    <svg width='1.1875rem' height='1.25rem' viewBox='0 0 19 20' {...props}>
        <g fill='#F55A5A' fillRule='nonzero'>
            <path
                d='M20.306 10c.459 0 .838.344.893.788l.007.113v2.525l7.628 1.048c.455.062.783.454.778.901l-.009.113c-.062.455-.454.784-.901.778l-.113-.008-1.17-.161-1.066 11.679c-.11 1.201-1.07 2.136-2.252 2.218l-.17.006h-7.25c-1.202 0-2.211-.88-2.4-2.054l-.022-.17-1.067-11.68-1.169.162c-.455.062-.877-.226-.992-.659l-.023-.11c-.062-.455.227-.878.66-.993l.11-.022 7.626-1.048.001-2.525c0-.46.344-.838.788-.894l.113-.007zm0 5.12l-5.328.731 1.075 11.76c.027.299.246.53.522.579l.106.009h7.25c.288 0 .536-.2.61-.479l.018-.108 1.074-11.76-5.327-.731z'
                transform='translate(-1387 -402) translate(40 356) translate(1208 36) translate(128)'
            />
        </g>
    </svg>
);

export default TrashCanIcon;
